import type { HttpClient } from '../http/HttpClient'
import type { UnitOption, UnitRepository } from '@/domain/unit/Unit'

export class HttpUnitRepository implements UnitRepository {
  constructor(private http: HttpClient) {}

  list(): Promise<UnitOption[]> {
    return this.http.url('purchases/units').get<UnitOption[]>()
  }
}
